import { Restaurant } from '@travel/icons/service';
import { MOBILE_SCREEN, useDeviceType } from '@travel/traveler-core/hooks';
import { IconTextTag } from '@travel/ui';
import { cx, isEmptyArray } from '@travel/utils';

import CustomMedium from 'favoriteList/components/CustomMedium';
import { TagsValue } from 'favoriteList/constants/favoriteLists';
import FavoriteButton, { FavoriteButtonType } from '../../FavoriteButton';
import ImageGallery from '../../ImageGallery';

import type { PlanListWithArrayIndex, Provider } from 'Plan-Types';

import styles from './planDetailInformationCard.module.scss';

type Props = {
  plan: PlanListWithArrayIndex;
  provider: Provider;
  handlePlanFavoriteButtonClick: (plan: PlanListWithArrayIndex) => void;
  isDomestic: boolean;
};

const PlanDetailInformationCard = (props: Props) => {
  const { plan, provider, handlePlanFavoriteButtonClick, isDomestic } = props;
  const deviceType = useDeviceType();
  const isSP = deviceType === MOBILE_SCREEN;

  const isDined = (plan: boolean) => (plan ? 'あり' : 'なし');
  const formatLowestPrice = plan.lowestPrice
    ? new Intl.NumberFormat('ja-JP').format(plan.lowestPrice)
    : '';
  const isEmptyTags = isEmptyArray(plan.tags);
  const isLowestPriceZeroOrNull = plan.lowestPrice === 0 || plan.lowestPrice === null;

  return (
    <>
      <section className={styles.hotelDetailsContainer}>
        <div className={styles.hotelDetailsBoarder}>
          <>
            {isSP ? (
              <div className={styles.photosAreaSP}>
                <CustomMedium
                  mediaArray={plan.media}
                  mediaClassName={styles.customMedia}
                  mediaWrapperClassName={styles.mediaWrapper}
                />
              </div>
            ) : (
              <ImageGallery
                media={plan.media}
                galleryType="slide"
                className={styles.mediaWrapper}
                mediaClassName={styles.customMedia}
              />
            )}
          </>
          <div className={styles.hotelDescriptionContainer}>
            <div className={styles.tagFavoriteArea}>
              {isEmptyTags ? (
                <a href={plan.planInfoUrl} className={styles.hotelDetailTitle}>
                  {plan.name}
                </a>
              ) : (
                <div className={styles.tagContainer}>
                  {plan.tags.map((tag, index) => (
                    <span key={index} className={styles.tagText}>
                      {TagsValue[tag]}
                    </span>
                  ))}
                </div>
              )}
              <FavoriteButton
                type={FavoriteButtonType.PLAN}
                plan={plan}
                provider={provider}
                handlePlanFavoriteButtonClick={handlePlanFavoriteButtonClick}
                isDomestic={isDomestic}
              />
            </div>
            <div className={styles.planAreaContainer}>
              {!isEmptyTags ? (
                <a href={plan.planInfoUrl} className={styles.hotelDetailTitle}>
                  {plan.name}
                </a>
              ) : null}
              <div className={styles.diningInformationContainer}>
                <div className={styles.diningArea}>
                  <div className={styles.diningTextContainer}>
                    <IconTextTag
                      className={styles.customIconClass}
                      color="default"
                      icon={<Restaurant size={16} color="sonicSilver" />}
                      label={
                        <p className={styles.diningText}>
                          朝食
                          {isDined(plan.isBreakfastIncluded)} 夕食
                          {isDined(plan.isDinnerIncluded)}
                        </p>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.priceBoxContainer}>
              {/* for flex display element */}
              <div>
                {isLowestPriceZeroOrNull ? null : (
                  <>
                    {isDomestic ? (
                      <>
                        {plan.lowestPriceDescription && (
                          <p className={styles.personCount}>{plan.lowestPriceDescription}</p>
                        )}
                        <h4 className={styles.priceText}>
                          {formatLowestPrice}
                          <strong className={styles.currencies}>{plan.lowestPriceUnit}</strong>
                        </h4>
                      </>
                    ) : (
                      <>
                        <h4 className={styles.priceText}>
                          {formatLowestPrice}
                          <strong className={styles.currencies}>{plan.lowestPriceUnit}</strong>
                        </h4>
                        {plan.lowestPriceDescription && (
                          <p className={styles.personCount}>{plan.lowestPriceDescription}</p>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
              {isEmptyTags && isLowestPriceZeroOrNull ? null : (
                <div
                  className={cx(
                    styles.detailButtonContainer,
                    isEmptyTags && !isLowestPriceZeroOrNull ? styles.onlyPrice : styles.tagExist,
                  )}
                >
                  <button className={styles.detailButton}>
                    <a className={styles.detailButtonTitle} href={plan.planInfoUrl}>
                      詳細を見る
                    </a>
                  </button>
                </div>
              )}
            </div>
            {isEmptyTags && isLowestPriceZeroOrNull ? (
              <div
                className={cx(
                  styles.detailButtonContainer,
                  isLowestPriceZeroOrNull && styles.noPrice,
                )}
              >
                <button className={styles.detailButton}>
                  <a className={styles.detailButtonTitle} href={plan.planInfoUrl}>
                    詳細を見る
                  </a>
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </section>
    </>
  );
};

export default PlanDetailInformationCard;
